import QuizOptionsPage from "../../features/dashboard/quiz/QuizOptionsPage";

function QuizOptionsDB() {
  return <QuizOptionsPage />;
}

export default QuizOptionsDB;
